import request from '@/utils/request.js'
import main from '@/main'


const state = {
  HotKeyword: [],
  BannerNavPreset: {
   /* hwy: [
      {
        title: '浪漫海岛',
        keyword: ['帕劳', '马尔代夫', '沙巴', '普吉岛']
      }, {
        title: '东南亚&南亚',
        keyword: ['泰国', '柬埔寨', '新加坡', '越南']
      }, {
        title: '台湾&日韩',
        keyword: ['台湾', '日本', '韩国']
      }, {
        title: '欧洲&澳非',
        keyword: ['欧洲', '澳洲', '迪拜', '埃及', '土耳其']
      }, {
        title: '美洲',
        keyword: ['美国', '加拿大', '墨西哥', '夏威夷']
      }
    ], */
    gny: [
      {
        title: '赏花季',
        keyword: ['福州', '贵州', '兴义', '扬州', '江西']
      }, {
        title: '温泉',
        keyword: ['黄山', '哈尔滨', '长白山', '济南', '泰安']
      }, {
        title: '境内外联游',
        keyword: ['金门岛', '下龙湾', '河内', '岘港', '会安']
      }
    ], zby: [
      {
        title: '香港游',
        keyword: ['海洋公园', '直通车', '香港']
      }, {
        title: '澳门游',
        keyword: ['直通车', '大三巴', '越南']
      }, {
        title: '热门城市',
        keyword: ['清远', '惠州', '连州', '新兴', '广州']
      }
    ], index: [
      {
        title: '出境游',
        keyword: ['南非', '欧洲', '泰国','仙本那']
      },
      {
        title: '国内游',
        keyword:['云南', '新疆', '北京', '湖南', '厦门']
      }, {
        title: '粤港澳',
        keyword: ['香港', '珠海', '澳门', '深圳']
      }, {
        title: '周边游',
        keyword:['韶关', '江门', '潮汕', '阳江','千古情']
      }, /*{
        title: '游轮',
        keyword: ['皇家加勒比', '星梦游轮', '歌诗达']
      }*/
    ]
  },
  BannerSwiperPreset: {
    index: [
      /*{
        title: '玄真漂流',
        img: '//filewww.fspits.com/File/2020/0723/20200723201626-cBnslshZnBnPssJI2Upcvp9hEuFom7sG.jpg',
        url: 'https://www.fspits.com/Product/Search?Keyword=%E7%8E%84%E7%9C%9F%E6%BC%82%E6%B5%81'
      },
      {
        title: '海泉湾',
        img: '//filewww.fspits.com/File/2021/0326/20210326114729-2cvPdazbvDH95aZWWOEmL3g5R9VXYASy.jpg',
        url: 'https://www.fspits.com/Product/Search?Keyword=海泉湾'
      },
      {
        title: '长隆欢乐世界',
        img: '//filewww.fspits.com/File/2020/0710/20200710155300-sX6GV3yyOKW4xIyNPZujcR1wK6WxMZBR.jpg',
        url: 'https://www.fspits.com/Product/Team?id=15036958&t=a5b1269e'
      }, {
        title: '冬日九寨沟',
        img: '//filewww.fspits.com/File/2019/1028/20191028170418-QEHv4bM3ffdDdSspMFJu2dd6YHfcQ783.jpg',
        url: 'https://m.fspits.com/Product/Search?Keyword=%E4%B9%9D%E5%AF%A8%E6%B2%9F'
      },*/
      /*{
        title: '翔顺金水台温泉小镇',
        img: '//filewww.fspits.com/File/2021/1117/20211117142809-aDFJy2VMlg0k5gpGHohn55pWEC6G9MtF.jpg',
        url: 'https://www.fspits.com/Product/Search?Keyword=翔顺金水台'
      }, {
        title: '维京游轮',
        img: '//filewww.fspits.com/File/2021/1117/20211117143254-RhDv5A6t5G0wsiT4LrymLp751AclUJdd.jpg',
        url: 'https://m.fspits.com/Product/Search?Keyword=维京游轮'
      },{
        title: '口岸文旅 20周年',
        img: '//filewww.fspits.com/File/2021/0819/20210819143342-OGNg2EkYqEr1kOtMnlvXchtJFD80Np0e.jpg',
        url: 'https://www.fspits.com/Product/Search?Keyword=口岸文旅 20周年'
      }, */
      {
        title: '广东省5A旅行社',
        img: '/static/images/banner4.jpg',
        url: 'https://www.fspits.com/Product/Search'
      }, {
        title: '广东佛山千古情',
        img: '/static/images/banner1.jpg',
        url: 'https://www.fspits.com/Product/Search?Keyword=千古情'
      },{
        title: '西藏桃花节',
        img: '/static/images/banner3.jpg',
        url: 'https://www.fspits.com/Product/Search?Keyword=西藏'
      }, {
        title: '仙本那玻璃海',
        img: '/static/images/banner2.jpg',
        url: 'https://www.fspits.com/Product/Search?Keyword=仙本那'
      }, {
        title: '私人订制',
        img: '//filewww.fspits.com/File/2023/0418/2023041801.jpg',
        url: 'https://www.fspits.com/Template/Customized?'
      }, {
        title: '口岸会员招募',
        img: '//filewww.fspits.com/File/2018/0306/20180306145206-SREMKMfcEtdgfKSLt5rSyVVcBKgwZbMg.jpg',
        url: 'https://www.fspits.com/Template/Customized?'
      },],
      
    hwy: [
      {
        title: '俄罗斯',
        img: '//filewww.fspits.com/File/2018/1227/20181227142056-5JUQiQK4zVdV09EvsYFp2fngyFjM9GHl.jpg',
        url: 'http://www.fspits.com/Product/Team/Show.php?Team_id=3574885'
      }, {
        title: '魅力土耳其',
        img: '//filewww.fspits.com/File/2018/0319/20180319113945-PqNT3clrOXCGVGVWG0sb3Uow1JMvR7fS.jpg',
        url: 'http://www.fspits.com/Product/Team/Show.php?Team_id=4280468'
      }, {
        title: '沙巴',
        img: '//filewww.fspits.com/File/2018/0212/20180212113125-jrDe6DXx6G7nVy6rwmmAcOz3A3IXjgvM.jpg',
        url: 'http://www.fspits.com/Product/Team/Show.php?Team_id=4174379'
      }, {
        title: '越南岘港',
        img: '//filewww.fspits.com/File/2018/0212/20180212113807-xeePOH57EuYRNqV9GnAGHHXw5Fy2X6Lc.jpg',
        url: 'http://www.fspits.com/Product/Team/Show.php?Team_id=4391566',
      }, {
        title: '奢华阿联酋',
        img: '//filewww.fspits.com/File/2018/0212/20180212113645-mm7chvz95YfzuhvOL8P7j70GKSapgjeG.jpg',
        url: 'http://www.fspits.com/Product/Team/Show.php?Team_id=4245349'
      }
    ],
    gny: [
      {
        title: '印象西藏',
        img: '//filewww.fspits.com/File/2018/0319/20180319105817-p8C3ehy1A1Q71MrO6mejsdNeVFmlKBeL.jpg',
        url: 'http://www.fspits.com/Product/Team/Show.php?Team_id=3642640'
      }, {
        title: '额济纳旗',
        img: '//filewww.fspits.com/File/2018/0827/20180827162543-9oFfLEsQJ7BaAK64dHxJw0Hn6A1Z3FGb.jpg',
        url: 'http://www.fspits.com/Product/Team/Show.php?Team_id=3739965'
      }, {
        title: '趣玩云南',
        img: '//filewww.fspits.com/File/2018/0411/20180411134523-bfP0UqBfyxlWO2jFxXiaYImSJFuXxwq1.jpg',
        url: 'http://www.fspits.com/Product/Team/Show.php?Team_id=4600289'
      }, {
        title: '玩转三亚',
        img: '//filewww.fspits.com/File/2018/0212/20180212112617-IdpYtDiIjJKeTEvo5h610MH8cmInELx2.jpg',
        url: 'http://www.fspits.com/Product/Team/Show.php?Team_id=4220881',
      }, {
        title: '北京5日游',
        img: '//filewww.fspits.com/File/2018/0827/20180827163227-YJAdgLugTVlLDoCIUYG4ceTbbdI0rNhF.jpg',
        url: 'http://www.fspits.com/Product/Team/Show.php?Team_id=1018950'
      }
    ],
    zby: [
      {
        title: '英德天鹅湖',
        img: '//filewww.fspits.com/File/2019/0524/20190524162407-ypbTIVwqq3otvLrnEg47XMCsn0OMUACf.jpg',
        url: 'http://www.fspits.com/Product/Team/Show.php?Team_id=9891026'
      }, {
        title: '全新融创乐园',
        img: '//filewww.fspits.com/File/2019/0524/20190524164139-a0QAykxL4QXaTIDyO6RmZP7afqPceYVw.jpg',
        url: 'http://www.fspits.com/Product/Search/index.php?ss=融创'
      }, {
        title: '南昆山“深”呼吸',
        img: '//filewww.fspits.com/File/2019/0524/20190524165152-CWYu9sna15DQ0QFQDcgwwfQ3jXqxJ2Dz.jpg',
        url: 'http://www.fspits.com/Product/Team/Show.php?Team_id=9888272'
      }, {
        title: '长隆童乐季',
        img: '//filewww.fspits.com/File/2019/0527/20190527103741-oFZrQsBHKWTkn2rFRBhLFFL5E2QSHnKJ.jpg',
        url: 'http://www.fspits.com/Product/Search/index.php?ss=长隆',
      }, {
        title: '网红水晶湖',
        img: '//filewww.fspits.com/File/2018/0827/20180827160230-lh8UwmWARC07LCCLarAMC0qH4GLF7pOI.jpg',
        url: 'http://www.fspits.com/Product/Team/Show.php?Team_id=2198802'
      }
    ]
  },
  BestSalerPreset: {
    index: [
      /*{
        title: '海外游',
        leftBoxPreset: {img: '/static/images/leftpro0.png', talk: ['精品出游', '尊贵享受'], keyword: ['日本', '泰国', '迪拜', '柬埔寨']},
        list: [
          {
            title: '热卖线路',
            Condition: {
              params: {
                ThisPage: 0,
                PageNum: 8
              },
              Keyword: null,
              TeamType: 1,
              RegisterHotKey: 0,
              sortKey: 'HotPoint',
              sortMode: 'desc'
            }
          }, {
            title: '欧洲',
            Condition: {
              params: {
                ThisPage: 0,
                PageNum: 8
              },
              Keyword: '欧洲',
              RegisterHotKey: 0,
              sortKey: 'HotPoint',
              sortMode: 'desc'
            }
          }, {
            title: '亚洲',
            Condition: {
              params: {
                ThisPage: 0,
                PageNum: 8
              },
              TeamType: 1,
              Keyword: '亚洲',
              RegisterHotKey: 0,
              sortKey: 'HotPoint',
              sortMode: 'desc'
            }
          }, {
            title: '非洲',
            Condition: {
              params: {
                ThisPage: 0,
                PageNum: 8
              },
              TeamType: 1,
              Keyword: '非洲',
              RegisterHotKey: 0,
              sortKey: 'HotPoint',
              sortMode: 'desc'
            }
          }, {
            title: '大洋洲',
            Condition: {
              params: {
                ThisPage: 0,
                PageNum: 8
              },
              TeamType: 1,
              Keyword: '大洋洲',
              RegisterHotKey: 0,
              sortKey: 'HotPoint',
              sortMode: 'desc'
            }
          }
        ]
      }, */
      {
        title: '国内游',
        leftBoxPreset: {img: '/static/images/leftpro1.png', talk: ['精品出游', '尊贵享受'], keyword: ['云南', '新疆', '北京', '湖南', '厦门']},
        list: [
          {
            title: '热卖线路',
            Condition: {
              params: {
                ThisPage: 0,
                PageNum: 6
              },
              Keyword: null,
              TeamType: 0,
              RegisterHotKey: 0,
              sortKey: 'HotPoint',
              sortMode: 'desc'
            }
          }, {
            title: '云南',
            Condition: {
              params: {
                ThisPage: 0,
                PageNum: 6
              },
              TeamType: 0,
              Keyword: '云南',
              RegisterHotKey: 0,
              sortKey: 'HotPoint',
              sortMode: 'desc'
            }
          }, {
            title: '新疆',
            Condition: {
              params: {
                ThisPage: 0,
                PageNum: 6
              },
              TeamType: 0,
              Keyword: '新疆',
              RegisterHotKey: 0,
              sortKey: 'HotPoint',
              sortMode: 'desc'
            }
          }, {
            title: '北京',
            Condition: {
              params: {
                ThisPage: 0,
                PageNum: 6
              },
              TeamType: 0,
              Keyword: '北京',
              RegisterHotKey: 0,
              sortKey: 'HotPoint',
              sortMode: 'desc'
            }
          }, {
            title: '湖南',
            Condition: {
              params: {
                ThisPage: 0,
                PageNum: 6
              },
              TeamType: 0,
              Keyword: '湖南',
              RegisterHotKey: 0,
              sortKey: 'HotPoint',
              sortMode: 'desc'
            }
          },
          {
            title: '厦门',
            Condition: {
              params: {
                ThisPage: 0,
                PageNum: 6
              },
              TeamType: 0,
              Keyword: '厦门',
              RegisterHotKey: 0,
              sortKey: 'HotPoint',
              sortMode: 'desc'
            }
          }
        ]
      }, {
        title: '周边游',
        leftBoxPreset: {img: '/static/images/leftpro2.png', talk: ['精品出游', '尊贵享受'], keyword: ['韶关', '江门', '潮汕', '梅州', '阳江','千古情']},
        list: [
          {
            title: '热卖线路',
            Condition: {
              params: {
                ThisPage: 0,
                PageNum: 6
              },
              TeamType: 2,
              Keyword: null,
              RegisterHotKey: 0,
              sortKey: 'HotPoint',
              sortMode: 'desc'
            }
          },
          {
            title: '韶关',
            Condition: {
              params: {
                ThisPage: 0,
                PageNum: 6
              },
              TeamType: 2,
              Keyword: '韶关',
              RegisterHotKey: 0,
              sortKey: 'HotPoint',
              sortMode: 'desc'
            }
          }, {
            title: '江门',
            Condition: {
              params: {
                ThisPage: 0,
                PageNum: 6
              },
              TeamType: 2,
              Keyword: '江门',
              RegisterHotKey: 0,
              sortKey: 'HotPoint',
              sortMode: 'desc'
            }
          }, {
            title: '潮汕',
            Condition: {
              params: {
                ThisPage: 0,
                PageNum: 6
              },
              TeamType: 2,
              Keyword: '潮汕',
              RegisterHotKey: 0,
              sortKey: 'HotPoint',
              sortMode: 'desc'
            }
          }, {
            title: '梅州',
            Condition: {
              params: {
                ThisPage: 0,
                PageNum: 6
              },
              TeamType: 2,
              Keyword: '梅州',
              RegisterHotKey: 0,
              sortKey: 'HotPoint',
              sortMode: 'desc'
            }
          }, {
            title: '阳江',
            Condition: {
              params: {
                ThisPage: 0,
                PageNum: 6
              },
              TeamType: 2,
              Keyword: '阳江',
              RegisterHotKey: 0,
              sortKey: 'HotPoint',
              sortMode: 'desc'
            }
          }, {
            title: '千古情',
            Condition: {
              params: {
                ThisPage: 0,
                PageNum: 6
              },
              TeamType: 2,
              Keyword: '千古情',
              RegisterHotKey: 0,
              sortKey: 'HotPoint',
              sortMode: 'desc'
            }
          }
        ]
      }, {
        title: '海外游',
        //leftBoxPreset: {img: '/static/images/leftpro0.png', talk: ['趣玩周边', '悦享生活'], keyword: ['三亚', '厦门', '丽江', '岘港', '清迈', '甲米', '巴厘岛', '仙本那']},
        leftBoxPreset: {img: '/static/images/leftpro0.png', talk: ['趣玩周边', '悦享生活'], keyword: ['南非', '欧洲', '泰国','仙本那']},
        list: [
          {
            title: '热卖线路',
            Condition: {
              params: {
                ThisPage: 0,
                PageNum: 9
              },
              Keyword: null,
              TeamType:1,
              RegisterHotKey: 0,
              sortKey: 'HotPoint',
              sortMode: 'desc'
            }
          }, {
            title: '南非',
            Condition: {
              params: {
                ThisPage: 0,
                PageNum: 6
              },
              Keyword: '南非',
              TeamType:1,
              RegisterHotKey: 0,
              sortKey: 'HotPoint',
              sortMode: 'desc'
            }
          }, {
            title: '欧洲',
            Condition: {
              params: {
                ThisPage: 0,
                PageNum: 6
              },
              Keyword: '欧',
              TeamType:1,
              RegisterHotKey: 0,
              sortKey: 'HotPoint',
              sortMode: 'desc'
            }
          }, {
            title: '泰国',
            Condition: {
              params: {
                ThisPage: 0,
                PageNum: 6
              },
              Keyword: '泰国',
              TeamType:1,
              RegisterHotKey: 0,
              sortKey: 'HotPoint',
              sortMode: 'desc'
            }
          }, {
            title: '仙本那',
            Condition: {
              params: {
                ThisPage: 0,
                PageNum: 6
              },
              Keyword: '仙本那',
              TeamType:1,
              RegisterHotKey: 0,
              sortKey: 'HotPoint',
              sortMode: 'desc'
            }
          }
        ]
      },
    ],
    hwy: [
      {
        title: '热门线路',
        leftBoxPreset: {img: '/static/images/cj_leftpro0.png', talk: ['日照黄金海岸', '激情日照'], keyword: ['新加坡', '美国', '加拿大', '岘港', '泰国']},
        list: [{
          title: '欧洲',
          Condition: {
            params: {
              ThisPage: 0,
              PageNum: 8
            },
            TeamType: 1,
            Keyword: '欧洲',
            RegisterHotKey: 0,
            sortKey: 'HotPoint',
            sortMode: 'desc'
          }
        }, {
          title: '亚洲',
          Condition: {
            params: {
              ThisPage: 0,
              PageNum: 8
            },
            TeamType: 1,
            Keyword: '亚洲',
            RegisterHotKey: 0,
            sortKey: 'HotPoint',
            sortMode: 'desc'
          }
        }, {
          title: '非洲',
          Condition: {
            params: {
              ThisPage: 0,
              PageNum: 8
            },
            TeamType: 1,
            Keyword: '非洲',
            RegisterHotKey: 0,
            sortKey: 'HotPoint',
            sortMode: 'desc'
          }
        }, {
          title: '美洲',
          Condition: {
            params: {
              ThisPage: 0,
              PageNum: 8
            },
            TeamType: 1,
            Keyword: '美洲',
            RegisterHotKey: 0,
            sortKey: 'HotPoint',
            sortMode: 'desc'
          }
        }
        ]
      }, {
        title: '口岸推荐',
        leftBoxPreset: {img: '/static/images/cj_leftpro1.png', talk: ['穿梭时间的隧道', '乐在其中'], keyword: ['马来西亚', '东京', '甲米', '越南', '芽庄', '澳洲']},
        list: [
          {
            title: null,
            Condition: {
              params: {
                ThisPage: 0,
                PageNum: 8
              },
              Keyword: null,
              TeamType: 1,
              RegisterHotKey: 0,
              sortKey: 'HotPoint',
              sortMode: 'desc'
            }
          },
        ]
      }, {
        title: '铁定成行',
        leftBoxPreset: {img: '/static/images/cj_leftpro2.png', talk: ['游山游水游天下', '口岸国旅伴您行'], keyword: ['英国', '沙巴', '东欧', '夏威夷', '美娜多', '美国东西岸']},
        list: [
          {
            title: null,
            Condition: {
              params: {
                ThisPage: 0,
                PageNum: 8
              },
              Keyword: null,
              TeamType: 1,
              IntoGroupState: 1,
              RegisterHotKey: 0,
              sortKey: 'HotPoint',
              sortMode: 'desc'
            }
          }
        ]
      },
    ],
    gny: [
      {
        title: '热门线路',
        leftBoxPreset: {img: '/static/images/gny_leftpro0.png', talk: ['富甲一方美', '盛揽天下境'], keyword: ['清海湖', '布达拉宫', '天山天池', '五台山', '响沙湾', '亚龙湾']},
        list: [
          {
            title: '热卖线路',
            Condition: {
              params: {
                ThisPage: 0,
                PageNum: 8
              },
              Keyword: null,
              TeamType: 0,
              RegisterHotKey: 0,
              sortKey: 'HotPoint',
              sortMode: 'desc'
            }
          },
        ]
      }, {
        title: '口岸推荐',
        leftBoxPreset: {img: '/static/images/gny_leftpro1.png', talk: ['越中古胜地', '活力新富盛'], keyword: ['西宁', '青海湖', '长沙', '湖北', '成都', '张家界']},
        list: [
          {
            title: null,
            Condition: {
              params: {
                ThisPage: 0,
                PageNum: 8
              },
              Keyword: '广西',
              TeamType: 0,
              RegisterHotKey: 0,
              sortKey: 'HotPoint',
              sortMode: 'desc'
            }
          },
        ]
      }, {
        title: '铁定成行',
        leftBoxPreset: {img: '/static/images/gny_leftpro2.png', talk: ['醉·乡村诗境', '赏·竹海风情'], keyword: ['海南', '广西', '厦门', '北京', '华东', '腾冲']},
        list: [
          {
            title: null,
            Condition: {
              params: {
                ThisPage: 0,
                PageNum: 8
              },
              IntoGroupState: 1,
              TeamType: 0,
              Keyword: null,
              RegisterHotKey: 0,
              sortKey: 'HotPoint',
              sortMode: 'desc'
            }
          }
        ]
      },
    ],
    zby: [
      {
        title: '热门线路',
        leftBoxPreset: {img: '/static/images/yga_leftpro0.png', talk: ['百里生态画卷', '千年人文英山'], keyword: ['阳江', '下川岛', '闸坡', '香港', '澳门', '高明']},
        list: [
          {
            title: '热卖线路',
            Condition: {
              params: {
                ThisPage: 0,
                PageNum: 8
              },
              Keyword: null,
              TeamType: 2,
              RegisterHotKey: 0,
              sortKey: 'HotPoint',
              sortMode: 'desc'
            }
          },
        ]
      }, {
        title: '口岸推荐',
        leftBoxPreset: {img: '/static/images/yga_leftpro1.png', talk: ['客聚赣县', '天下一家'], keyword: ['长隆', '珠海', '番禺', '深圳', '惠州', '潮汕']},
        list: [
          {
            title: '热卖线路',
            Condition: {
              params: {
                ThisPage: 0,
                PageNum: 8
              },
              Keyword: '肇庆',
              TeamType: 2,
              RegisterHotKey: 0,
              sortKey: 'HotPoint',
              sortMode: 'desc'
            }
          }
        ]
      }, {
        title: '铁定成行',
        leftBoxPreset: {img: '/static/images/yga_leftpro2.png', talk: ['富甲一方美', '盛揽天下境'], keyword: ['香港', '澳门', '开平', '双月湾', '南澳岛', '恩平']},
        list: [
          {
            title: '台山',
            Condition: {
              params: {
                ThisPage: 0,
                PageNum: 8
              },
              IntoGroupState: 1,
              TeamType: 2,
              Keyword: null,
              RegisterHotKey: 0,
              sortKey: 'HotPoint',
              sortMode: 'desc'
            }
          }
        ]
      },
    ]
  }
};

const mutations = {
  setHotKeyword(state, view) {
    state.HotKeyword = view;
  }
};

const actions = {
  checkHotKeyword({commit}, view) {
    this.dispatch("Function/Product/Search/GetHotKeyword", {}).then((res) => {
      commit('setHotKeyword', res);
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js